'use strict';

var toastMessageHelper = require('../utils/toastMessageHelper');

var $pdpwishlist = $('.product-detail');

var addMsg1 = $pdpwishlist.data('cartmsg');
var wishlistTitle1 = $pdpwishlist.data('wishlisttile');
var wishlistmsg1 = $pdpwishlist.data('removelabel');
var removedtile1 = $pdpwishlist.data('removedtile');

$('.wishlists-btn').on('click', function (e) {
    e.preventDefault();
    var $form = $(this);
    var $button = $form.find('.pdpwishlist-btn');
    var productId = $button.data('pid');
    if ($('.isAuthenticated').val() !== 'true') {
        $('.country-select-wrap').addClass('d-none');
        $('#loginInput').addClass('w-100');
        $('login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
        window.localStorage.setItem('wishlistPid', productId);
        $('#ckc-login-modal').modal('show');
    } else {
        var $iconUse = $button.find('use');

        var isInWishlist = $button.hasClass('is-active');

        var url = isInWishlist ? $button.data('remove-url') : $button.data('add-url');
        var method = isInWishlist ? 'GET' : 'POST';

        $.ajax({
            url: url,
            method: method,
            data: {
                pid: productId
            },
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    $button.toggleClass('is-active');
                    var isNowInWishlist = $button.hasClass('is-active');

                    $('body').trigger('wishlist:sync', {
                        pid: productId,
                        isActive: isNowInWishlist
                    });

                    $iconUse.attr('xlink:href', isNowInWishlist ? '#redpdp-wishlisticon' : '#dpd-wishlisticon');

                    if (isNowInWishlist) {
                        toastMessageHelper.showNotification(wishlistTitle1, addMsg1, 'wishlistfilledredicon');
                        $('.toast-icon').removeClass('removed-wishlist');
                    } else {
                        toastMessageHelper.showNotification(removedtile1, wishlistmsg1, 'wishlistnormalicon');
                        $('.toast-icon').addClass('removed-wishlist');
                    }
                }
            },
            error: function () {
                toastMessageHelper.showNotification(
                    'UNFORTUNATELY !',
                    'Something went wrong. Please try again.'
                );
            }
        });
    }
});

$('#ckc-login-modal').on('hidden.bs.modal', function () {
    window.localStorage.removeItem('wishlistPid');
});
